<template>
    <div style="line-height: 1.7em;">
        <br />
        <v-snackbar v-model="snackbar" :top="true" :color="color" :timeout="6000">
            <span v-if="snackbar_msg != null">{{ snackbar_msg }}</span>
            <v-btn dark text @click="snackbar = false">Close</v-btn>
        </v-snackbar>
          <v-row dense>
                <v-btn class="ma-2 no-display" tile outlined color="warning" @click="print()"> <v-icon
                        left>mdi-printer</v-icon> Print <v-icon right></v-icon> </v-btn>
            </v-row>

        <v-card class="box pagebreak card" v-for="student in leraner_marksheet" :key="student.reg_no">     
            <div :class="tenant === 'saisa' ? 'saisa-watermark' : ''">

                <img v-if="tenant === 'saisa' && org_basic_data.watermark" :src="org_basic_data.watermark"
                    class="watermark-img" alt="" />     
            <!-- <v-col cols="12" sm="12" md="12"> -->
            <v-row justify="center" class="page-top">
                <v-col cols="12" sm="2" md="2">
                    <v-row v-if="org_basic_data.school_logo && tenant !== 'saisa'" dense justify="center">
                        <img :src="org_basic_data.school_logo" width="60%" alt="logo" />
                    </v-row>
                </v-col>
                <v-col cols="12" sm="8" md="8">
                    <v-row v-if="org_basic_data.trust_name" dense justify="center">
                        <strong>
                            <h4>{{ org_basic_data.trust_name }}</h4>
                        </strong>
                    </v-row>
                    <v-row dense v-if="org_basic_data.school_name" justify="center">
                        <strong>
                            <h1>{{ org_basic_data.school_name }}</h1>
                        </strong>
                    </v-row>
                    <v-row v-if="org_basic_data.address" dense justify="center">
                        <h4>{{ org_basic_data.address }}</h4>
                    </v-row>
                    <v-row dense justify="center" v-if="org_basic_data.email && org_basic_data.phone">
                        <h4>
                            Phone : {{ org_basic_data.phone }} <span class="pl-2"></span> Email : {{
                            org_basic_data.email }}
                        </h4>
                    </v-row>
                    <v-row v-if="org_basic_data.website" dense justify="center">
                        <h4>Website : {{ org_basic_data.website }}</h4>
                    </v-row>
                </v-col>
                <v-col cols="12" sm="2" md="2">
                    <v-row v-if="org_basic_data.trust_logo" dense justify="center">
                        <img :src="org_basic_data.trust_logo" width="75%" alt="logo" />
                        <!-- 1130534 -->
                        <span v-if="org_basic_data.cbsc_no && tenant !== 'saisa'">
                            <h5>
                                CBSE Affiliation No. - {{ org_basic_data.cbsc_no }}
                            </h5>
                        </span>
                    </v-row>
                </v-col>
            </v-row>
            <v-row dense justify="center" style="margin-top: -10px;">
                <span class="text_report">
                    <strong class="print-font"><v-col cols="12" sm="12" md="12"> Score Card A.Y. {{ student.ay }}</v-col>
                    </strong>
                </span>
            </v-row>
            <!-- <br /> -->
            <v-row dense class="stud-info font-size">
                <v-col cols="12" sm="10" md="10">
                    <v-row dense>
                      <v-col cols="12" sm="6" md="6"><strong>Name : </strong> {{ student.name }} </v-col>
                      <v-col cols="12" sm="6" md="6"> <strong>Roll No. : </strong> {{ student.roll_no }} </v-col>
                      <v-col cols="12" sm="6" md="6"><strong>Grade & Division : </strong>{{ student.standard }} {{ student.div }} </v-col>
                      <v-col cols="12" sm="6" md="6"><strong>PRN : </strong>{{ student.reg_no }} </v-col>
                      <v-col cols="12" sm="6" md="6"> <strong>Date of Birth : </strong> {{ student.dob }} </v-col>
                      <v-col cols="12" sm="6" md="6"> <strong>G.R. No. : </strong> {{ student.gr_no }}</v-col>
                      <v-col cols="12" sm="6" md="6"><strong>Father's Name : </strong> {{ student.father_full_name }} </v-col>
                      <v-col cols="12" sm="6" md="6"><strong>Father's Contact No. : </strong> {{ student.father_contact }} </v-col>
                      <v-col cols="12" sm="6" md="6"> <strong>Mother's Name : </strong> {{ student.mother_name }} </v-col>
                      <v-col cols="12" sm="6" md="6"> <strong>Mother's Contact No. : </strong> {{ student.mother_contact }} </v-col>
                        <!-- <v-col cols="12" sm="12" md="12">
              <strong>Residential Address : </strong> {{ address }}
            </v-col> -->
                    </v-row>
                </v-col>
                <v-col cols="12" sm="2" md="2" v-if="student.photo != null">
                    <img class="ml-5" :src="awspath + student.photo" style="width: 160px; height: 160px;" alt="logo" />
                </v-col>
                <v-col cols="12" sm="2" md="2" v-else>
                    <img class="ml-5" src="https://eduplusschool.s3.ap-south-1.amazonaws.com/User_avatar.jpeg"
                        style="width: 160px; height: 160px;" alt="logo" />
                </v-col>
            </v-row>
            <v-row dense class="stud-info addrss font-size">
                <v-col cols="12" sm="12" md="12" justify="left" align="left">
                    <strong>Residential Address : </strong>

                    <span>
                        {{ student.address }}
                    </span>
                </v-col>
            </v-row>
            <!-- </v-col> -->
            <br />
            <div class="div">
                <v-col cols="12" sm="12" md="12">
                    <v-simple-table v-if="student.leraner_marksheet != ''" dense class="elevation-1">
                        <thead>
                            <tr>
                                <td>
                                    <center>Scholastic Areas</center>
                                </td>
                                <td v-if="student.leraner_marksheet.is_admitted_for_term_1 == true"
                                    :colspan="student.leraner_marksheet.ass_details_for_marksheet.length">
                                    <center>{{ student.leraner_marksheet.sem1 }}</center>
                                </td>
                                <td :colspan="student.leraner_marksheet.ass_details_for_marksheet_sem2.length
                                    ">
                                    <center>{{ student.leraner_marksheet.sem2 }}</center>
                                </td>
                                <td rowspan="2">
                                    <center>Overall Grade</center>
                                </td>
                            </tr>

                            <tr>
                                <td class="">
                                    <center>Subject Name</center>
                                </td>
                                <td class="" v-for="header in student.leraner_marksheet.ass_details_for_marksheet"
                                    :key="header">
                                    <center>{{ header }}</center>
                                </td>
                                <td class="" v-for="header in student.leraner_marksheet.ass_details_for_marksheet_sem2"
                                    :key="header">
                                    <center>{{ header }}</center>
                                </td>
                            </tr>
                        </thead>
                        <tbody>
                            <tr v-for="(s, index) in student.leraner_marksheet.learner_marksheet_data_scholastic" :key="index">
                                <td>
                                    <center>{{ index }}</center>
                                </td>
                                <td v-for="(sem1, index1) in s[0] || []" :key="index1">
                                    <center>{{ sem1 }}</center>
                                </td>
                                <td v-for="(sem2, index2) in s[1] || []" :key="index2">
                                    <center>{{ sem2 }}</center>
                                </td>
                                <td v-for="(overall_data, index3) in s[2] || []" :key="index3">
                                    <center>{{ overall_data }}</center>
                                </td>
                            </tr>
                        </tbody>
                    </v-simple-table>
                </v-col>
            </div>
            <br />
            <v-row dense justify="center" v-if="student.leraner_marksheet.show_grade == 'YES'">
                <span class="text_report"> 
                    <v-col cols="12" sm="12" md="12"> 
                        <strong> 
                            Overall (All Subject) Percentage : {{ student.leraner_marksheet.overall_percentage }}
                        </strong>
                    </v-col>
                </span>
                <span class="text_report"> 
                    <v-col cols="12" sm="12" md="12"> 
                        <strong> 
                            Overall (All Subject) Grade : {{ student.leraner_marksheet.overall_grade }}
                        </strong>
                    </v-col>
                </span>
            </v-row>
            <v-row v-else dense justify="center">
                <span class="text_report" style="width: 30%;font-size: larger;">
                    <strong><v-col cols="12" sm="12" md="12">
                            <center> Overall Grade (All Subject): {{ student.leraner_marksheet.overall_grade }}</center>
                        </v-col> </strong>
                </span>
            </v-row>
            <!-- <br /> -->
            <v-col v-if="student.leraner_marksheet.is_admitted_for_term_1 == true" cols="12" sm="12" md="12">
                <v-simple-table v-if="student.leraner_marksheet != ''" fixed-header dense class="elevation-1">
                    <thead>
                        <tr>
                            <td colspan="4">
                                <center>Co-Scholastic Areas</center>
                            </td>
                        </tr>
                        <tr>
                            <td>
                                <center>{{ student.leraner_marksheet.sem1 }}</center>
                            </td>
                            <td>
                                <center>Grade</center>
                            </td>
                            <td>
                                <center>{{ student.leraner_marksheet.sem2 }}</center>
                            </td>
                            <td>
                                <center>Grade</center>
                            </td>
                        </tr>
                    </thead>
                    <tbody>
                        <tr v-for="(
s, index2
            ) in student.leraner_marksheet.leraner_coscholastic_marksheet" :key="index2">
                            <td>
                                <center>{{ index2 }}</center>
                            </td>
                            <td v-for="(sem1, index1) in s[0]" :key="index1">
                                <center>{{ sem1 }}</center>
                            </td>
                            <td>
                                <center>{{ index2 }}</center>
                            </td>
                            <td v-for="(sem2, index3) in s[1]" :key="index3">
                                <center>{{ sem2 }}</center>
                            </td>
                        </tr>
                    </tbody>
                </v-simple-table>
            </v-col>
            <v-col v-else cols="12" sm="12" md="12">
                <v-simple-table v-if="student.leraner_marksheet != ''" fixed-header dense class="elevation-1">
                    <thead>
                        <tr>
                            <td colspan="4">
                                <center>Co-Scholastic Areas</center>
                            </td>
                        </tr>
                        <tr>
                            <td>
                                <center>{{ student.leraner_marksheet.sem2 }}</center>
                            </td>
                            <td>
                                <center>Grade</center>
                            </td>
                        </tr>
                    </thead>
                    <tbody>
                        <tr v-for="(
s, index2
            ) in student.leraner_marksheet.leraner_coscholastic_marksheet" :key="index2">
                            <td>
                                <center>{{ index2 }}</center>
                            </td>
                            <td v-for="(sem2, index3) in s[1]" :key="index3">
                                <center>{{ sem2 }}</center>
                            </td>
                        </tr>
                    </tbody>
                </v-simple-table>
            </v-col>
            <br />
            <span v-if="student.leraner_marksheet.is_admitted_for_term_1 == true">
                <v-col cols="12" sm="12" md="12" v-if="tenant !== 'saisa'">
                    <v-simple-table v-if="student.leraner_marksheet != '' && student.leraner_marksheet.leraner_other_marksheet.length > 0" fixed-header dense class="elevation-1">
                        <thead>
                            <tr>
                                <td>
                                    <center>{{ student.leraner_marksheet.sem1 }}</center>
                                </td>
                                <td>
                                    <center>Grade</center>
                                </td>
                                <td>
                                    <center>{{ student.leraner_marksheet.sem2 }}</center>
                                </td>
                                <td>
                                    <center>Grade</center>
                                </td>
                            </tr>
                        </thead>
                        <tbody>
                            <tr v-for="(s, index2) in student.leraner_marksheet.leraner_other_marksheet" :key="index2">
                                <td>
                                    <center>{{ index2 }}</center>
                                </td>
                                <td v-for="(sem1, index1) in s[0]" :key="index1">
                                    <center>{{ sem1 }}</center>
                                </td>
                                <td>
                                    <center>{{ index2 }}</center>
                                </td>
                                <td v-for="(sem2, index3) in s[1]" :key="index3">
                                    <center>{{ sem2 }}</center>
                                </td>
                            </tr>
                        </tbody>
                    </v-simple-table>
                </v-col>
                <v-col cols="12" sm="12" md="12" v-if="student.leraner_marksheet.display_bmi == 'True'">
                    <v-simple-table v-if="student.leraner_marksheet != ''" fixed-header dense class="elevation-1">
                        <!-- <thead> -->
                        <tr>
                            <td rowspan="3">
                                <center><strong>Health Status</strong></center>
                            </td>
                            <td colspan="3">
                                <center>
                                    <strong>{{ student.leraner_marksheet.sem1 }}</strong>
                                </center>
                            </td>
                            <td colspan="3">
                                <center>
                                    <strong>{{ student.leraner_marksheet.sem2 }}</strong>
                                </center>
                            </td>
                        </tr>
                        <!-- </thead>
                      <tbody> -->
                        <tr>
                            <td>
                                <center>Height (cm)</center>
                            </td>
                            <td>
                                <center>Weight (kg)</center>
                            </td>
                            <td>
                                <center>BMI</center>
                            </td>
                            <td>
                                <center>Height (cm)</center>
                            </td>
                            <td>
                                <center>Weight (kg)</center>
                            </td>
                            <td>
                                <center>BMI</center>
                            </td>
                        </tr>
                        <tr>
                            <td v-for="(s, index2) in student.leraner_marksheet.user_bmi_list_sem1" :key="index2">
                                <center>{{ s }}</center>
                            </td>
                            <td v-for="(s, index2) in student.leraner_marksheet.user_bmi_list_sem2" :key="index2">
                                <center>{{ s }}</center>
                            </td>
                        </tr>
                        <!-- </tbody> -->
                    </v-simple-table>
                </v-col>
            </span>
            <span v-else>
                <v-col cols="12" sm="12" md="12" v-if="tenant !== 'saisa'">
                    <v-simple-table v-if="student.leraner_marksheet != ''" fixed-header dense class="elevation-1">
                        <thead>
                            <tr>
                                <td>
                                    <center>{{ student.leraner_marksheet.sem2 }}</center>
                                </td>
                                <td>
                                    <center>Grade</center>
                                </td>
                            </tr>
                        </thead>
                        <tbody>
                            <tr v-for="(s, index2) in student.leraner_marksheet.leraner_other_marksheet" :key="index2">
                                <td>
                                    <center>{{ index2 }}</center>
                                </td>
                                <td v-for="(sem2, index3) in s[1]" :key="index3">
                                    <center>{{ sem2 }}</center>
                                </td>
                            </tr>
                        </tbody>
                    </v-simple-table>
                </v-col>
                <v-col cols="12" sm="12" md="12" v-if="student.leraner_marksheet.display_bmi == 'True'">
                    <v-simple-table v-if="student.leraner_marksheet != ''" fixed-header dense class="elevation-1">
                        <!-- <thead> -->
                        <tr>
                            <td rowspan="3">
                                <center><strong>Health Status</strong></center>
                            </td>
                            <td colspan="3">
                                <center>
                                    <strong>{{ student.leraner_marksheet.sem2 }}</strong>
                                </center>
                            </td>
                        </tr>
                        <!--                             
                      </thead>
                      <tbody> -->
                        <tr>
                            <td>
                                <center>Height (cm)</center>
                            </td>
                            <td>
                                <center>Weight (kg)</center>
                            </td>
                            <td>
                                <center>BMI</center>
                            </td>
                        </tr>
                        <tr>
                            <td v-for="(s, index2) in student.leraner_marksheet.user_bmi_list_sem2" :key="index2">
                                <center>{{ s }}</center>
                            </td>
                        </tr>
                        <!-- </tbody> -->
                    </v-simple-table>
                </v-col>
            </span>
            <v-col cols="12" sm="12" md="12" v-if="student.leraner_marksheet.display_att == 'True'">
                <v-simple-table v-if="student.leraner_marksheet != ''" fixed-header dense class="elevation-1">
                    <thead>
                        <tr>
                            <td>
                                <center>Attendance</center>
                            </td>
                            <td>
                                <center>{{ student.leraner_marksheet.sem1 }}</center>
                            </td>
                            <td>
                                <center>{{ student.leraner_marksheet.sem2 }}</center>
                            </td>
                        </tr>
                    </thead>
                    <tbody>
                        <tr>
                            <td>
                                <center>
                                    <strong>Total Attendance of the Student</strong>
                                </center>
                            </td>
                            <td v-for="(s, index2) in student.leraner_marksheet.sem1_attendance" :key="index2">
                                <center>{{ s.present }} / {{ s.total_working_stud }}</center>
                            </td>
                            <td v-for="(s, index2) in student.leraner_marksheet.sem2_attendance" :key="index2">
                                <center>{{ s.present }} / {{ s.total_working_stud }}</center>
                            </td>
                        </tr>
                        <!-- <tr>
                          <td>
                              <center><strong>Total Working Days</strong></center>
                          </td>
                          <td v-for="(s, index2) in leraner_marksheet.sem1_attendance" :key="index2">
                              <center>{{ s.total_working_stud }}</center>
                          </td>
                          <td v-for="(s, index2) in leraner_marksheet.sem2_attendance" :key="index2">
                              <center>{{ s.total_working_stud }}</center>
                          </td>
                      </tr> -->
                    </tbody>
                </v-simple-table>
            </v-col>
            </div>
            <!-- <br /> -->
            <div v-if="tenant !== 'saisa'">
                <v-col cols="12" sm="12" md="12" class="font-size">
                    <strong>Class Teacher's Remarks : </strong>
                    {{ student.leraner_marksheet.lms_remark }}
                </v-col>
                <br />
                <v-row class="ml-5 font-size" dense justify="center">
                    <v-col cols="12" sm="8" md="8">
                        <span class="mr-2" style="border-bottom: 3px solid #000; padding-bottom: 3px;">{{ student.name }}
                        </span>
                        is Passed and Promoted to
                        <span style="border-bottom: 3px solid #000; padding-bottom: 3px;">Grade {{
                            student.leraner_marksheet.next_std }}</span>
                    </v-col>
                    <v-col cols="12" sm="4" md="4">
                        New session begins on :
                        <span class="mr-2" style="border-bottom: 3px solid #000; padding-bottom: 3px;">{{
                            student.leraner_marksheet.sessiondate_std }}</span>
                    </v-col>
                </v-row>
                <br />
                <br />
                <br />
                <br />
                <br />
                <br />
                <v-col cols="12" sm="12" md="12">
                    <v-row dense justify="center" class="font-size">
                        <v-col cols="12" sm="4" md="4">
                            Date : {{ student.leraner_marksheet.lms_result_date }}
                        </v-col>
                        <v-col cols="12" sm="4" md="4"> Signature of Class Teacher </v-col>
                        <v-col cols="12" sm="4" md="4"> Signature of Principal </v-col>
                    </v-row>
                </v-col>
                <v-container fill-height>
                    <v-row class="full-height" dense justify="center" align="center">
                        <div class="pagebreak">
                            <v-row dense justify="center">
                                <span class="text_report">
                                    <strong><v-col cols="12" sm="12" md="12" style="width: 400px;"> Scholastic Areas
                                            (Grading on {{ student.leraner_marksheet.scholastic_grade }} Point Scale)</v-col>
                                    </strong>
                                </span>
                            </v-row>
                            <v-row dense justify="center">
                                <v-simple-table class="elevation-1" style="width: 400px;">
                                    <thead>
                                        <tr>
                                            <td class="">
                                                <center>Sr. No.</center>
                                            </td>
                                            <td class="">
                                                <center>Grade Name</center>
                                            </td>
                                            <td class="">
                                                <center>Percentage Range</center>
                                            </td>
                                            <!-- <td class=""><center>Grade Point</center></td> -->
                                        </tr>
                                    </thead>
                                    <tbody>
                                        <tr v-for="(s, index) in student.leraner_marksheet.grade_details" :key="s.g_id">
                                            <td>
                                                <center>{{ index + 1 }}</center>
                                            </td>
                                            <td>
                                                <center>{{ s.gradename }}</center>
                                            </td>
                                            <td>
                                                <center>{{ s.range }}</center>
                                            </td>
                                            <!-- <td>{{s.gradepoint}}</td> -->
                                        </tr>
                                    </tbody>
                                </v-simple-table>
                            </v-row>
                            <v-row dense justify="center" v-if="student.leraner_marksheet.cograde_details.length > 0">
                                <span class="text_report">
                                    <strong><v-col cols="12" sm="12" md="12" style="width: 400px; font-size: 17px;">
                                            Co-Scholastic Areas (Grading on {{ student.leraner_marksheet.coscholastic_grade }}
                                            Point Scale)</v-col> </strong>
                                </span>
                            </v-row>
                            <v-row dense justify="center" v-if="student.leraner_marksheet.cograde_details.length > 0">
                                <v-simple-table fixed-header dense class="elevation-1" style="width: 400px;">
                                    <thead>
                                        <tr>
                                            <td class="">
                                                <center>Sr. No.</center>
                                            </td>
                                            <td class="">
                                                <center>Grade Name</center>
                                            </td>
                                            <td class="">
                                                <center>Grade Point</center>
                                            </td>
                                            <!-- <td class=""><center>Grade Point</center></td> -->
                                        </tr>
                                    </thead>
                                    <tbody>
                                        <tr v-for="(s, index) in student.leraner_marksheet.cograde_details" :key="s.g_id">
                                            <td>
                                                <center>{{ index + 1 }}</center>
                                            </td>
                                            <td>
                                                <center>{{ s.gradename }}</center>
                                            </td>
                                            <td>
                                                <center>{{ s.range }}</center>
                                            </td>
                                            <!-- <td>{{s.gradepoint}}</td> -->
                                        </tr>
                                    </tbody>
                                </v-simple-table>
                            </v-row>
                            <v-col cols="12" sm="11" md="11" class="font-size">
                                <ol class="fixed-list">
                                    <li>
                                        Students must obtain the qualifying grade (minimum grade D) in all subjects
                                        under Scholastic area and qualifying grade (minimum grade C) in Co-Scholastic
                                        area.
                                    </li>
                                    <li>
                                        D* indicates Conditionally Promoted.
                                    </li>
                                    <li v-if="allowedStandards.includes(student.standard)">
                                        FA-I & II is Formative Assessment -I & II and SA-I & II is Summative Assessment
                                        - I & II.
                                    </li>
                                </ol>
                            </v-col>
                        </div>
                    </v-row>
                </v-container>
            </div>
            <div class="pagebreak saisa-watermark" v-else>
                <img v-if="org_basic_data.watermark" :src="org_basic_data.watermark" class="watermark-img" alt="" />
                <v-col cols="12" sm="12" md="12" class="font-size">
                    <strong>Class Teacher's Remarks : </strong>
                    {{ student.leraner_marksheet.lms_remark }}
                </v-col>
                <br />
                <v-row class="ml-5 font-size" dense justify="center">
                    <v-col cols="12" sm="8" md="8">
                        <span class="mr-2" style="border-bottom: 3px solid #000; padding-bottom: 3px;">{{ student.name }}
                        </span>
                        is Passed and Promoted to
                        <span style="border-bottom: 3px solid #000; padding-bottom: 3px;">Grade {{
                            student.leraner_marksheet.next_std }}</span>
                    </v-col>
                    <v-col cols="12" sm="4" md="4">
                        New session begins on :
                        <span class="mr-2" style="border-bottom: 3px solid #000; padding-bottom: 3px;">{{
                            student.leraner_marksheet.sessiondate_std }}</span>
                    </v-col>
                </v-row>
                <br />
                <br />
                <br />
                <br />
                <br />
                <br />
                <div class="signature-section" style="display:flex; justify-content:space-between;">    
                    <div style="text-align:center; padding:0 10px; width:33%;">
                        <div style="height:150px; display:flex; flex-direction:column; justify-content:flex-end;">
                            <strong>
                                Date : {{ student.leraner_marksheet.lms_result_date || '--' }}
                            </strong>
                        </div>
                    </div>

                    <div style="text-align:center; padding:0 10px; width:33%;">
                        <div style="height:150px; display:flex; flex-direction:column; justify-content:flex-end;">
                            
                            <div v-if="student.class_teacher_sign">
                                <img :src="awspath + student.class_teacher_sign" 
                                    style="max-height: 70px; max-width: 200px;" />
                            </div>
                            <div v-else>
                                <strong>{{ student.class_teacher_name }}</strong>
                            </div>

                            <div class="mt-2">
                                <strong>Signature of Class Teacher</strong>
                            </div>
                        </div>
                    </div>

                    <div style="text-align:center; padding:0 10px; width:33%;">
                        <div style="height:150px; display:flex; flex-direction:column; justify-content:flex-end;">
                            
                            <div v-if="student.head_master_sign">
                                <img :src="awspath + student.head_master_sign" 
                                    style="max-height: 70px; max-width: 200px;" />
                            </div>
                            <div v-else>
                                <strong>{{ student.head_master_name }}</strong>
                            </div>

                            <div class="mt-2">
                                <strong>Signature of Principal</strong>
                            </div>
                        </div>
                    </div>x
                </div>
                <v-container>
                    <v-row class="" dense justify="center" align="center">
                        <div>
                            <v-row dense justify="center">
                                <span class="text_report">
                                    <strong><v-col cols="12" sm="12" md="12" style="width: 400px;"> Scholastic Areas
                                            (Grading on {{ student.leraner_marksheet.scholastic_grade }} Point Scale)</v-col>
                                    </strong>
                                </span>
                            </v-row>
                            <v-row dense justify="center">
                                <v-simple-table class="elevation-1" style="width: 400px;">
                                    <thead>
                                        <tr>
                                            <td class="">
                                                <center>Sr. No.</center>
                                            </td>
                                            <td class="">
                                                <center>Grade Name</center>
                                            </td>
                                            <td class="">
                                                <center>Percentage Range</center>
                                            </td>
                                            <!-- <td class=""><center>Grade Point</center></td> -->
                                        </tr>
                                    </thead>
                                    <tbody>
                                        <tr v-for="(s, index) in student.leraner_marksheet.grade_details" :key="s.g_id">
                                            <td>
                                                <center>{{ index + 1 }}</center>
                                            </td>
                                            <td>
                                                <center>{{ s.gradename }}</center>
                                            </td>
                                            <td>
                                                <center>{{ s.range }}</center>
                                            </td>
                                            <!-- <td>{{s.gradepoint}}</td> -->
                                        </tr>
                                    </tbody>
                                </v-simple-table>
                            </v-row>
                            <v-row dense justify="center" v-if="student.leraner_marksheet.cograde_details.length > 0">
                                <span class="text_report">
                                    <strong><v-col cols="12" sm="12" md="12" style="width: 400px; font-size: 17px;">
                                            Co-Scholastic Areas (Grading on {{ student.leraner_marksheet.coscholastic_grade }}
                                            Point Scale)</v-col> </strong>
                                </span>
                            </v-row>
                            <v-row dense justify="center" v-if="student.leraner_marksheet.cograde_details.length > 0">
                                <v-simple-table fixed-header dense class="elevation-1" style="width: 400px;">
                                    <thead>
                                        <tr>
                                            <td class="">
                                                <center>Sr. No.</center>
                                            </td>
                                            <td class="">
                                                <center>Grade Name</center>
                                            </td>
                                            <td class="">
                                                <center>Grade Point</center>
                                            </td>
                                            <!-- <td class=""><center>Grade Point</center></td> -->
                                        </tr>
                                    </thead>
                                    <tbody>
                                        <tr v-for="(s, index) in student.leraner_marksheet.cograde_details" :key="s.g_id">
                                            <td>
                                                <center>{{ index + 1 }}</center>
                                            </td>
                                            <td>
                                                <center>{{ s.gradename }}</center>
                                            </td>
                                            <td>
                                                <center>{{ s.range }}</center>
                                            </td>
                                            <!-- <td>{{s.gradepoint}}</td> -->
                                        </tr>
                                    </tbody>
                                </v-simple-table>
                            </v-row>
                            <v-col cols="12" sm="11" md="11" class="font-size">
                                <ol class="fixed-list">
                                    <li>
                                        Students must obtain the qualifying grade (minimum grade D) in all subjects
                                        under Scholastic area and qualifying grade (minimum grade C) in Co-Scholastic
                                        area.
                                    </li>
                                    <li>
                                        D* indicates Conditionally Promoted.
                                    </li>
                                    <li v-if="allowedStandards.includes(student.standard)">
                                        FA-I & II is Formative Assessment -I & II and SA-I & II is Summative Assessment
                                        - I & II.
                                    </li>
                                </ol>
                            </v-col>
                        </div>
                    </v-row>
                </v-container>
            </div>
        </v-card>
        <v-overlay :value="overlay">
            <v-progress-circular indeterminate size="64"></v-progress-circular>
        </v-overlay>
        </div>
</template>
<script>
import axios from "axios";
import jsPDF from "jspdf";
import "jspdf-autotable";
import "@/assets/css/color.css"; // css needs to be imported for each dashboard
export default {
    props: {
        org: Number,
    },
    data() {
        return {
            default_value: [],
            dialog_marks: false,
            overlay: false,
            selected: [],
            snackbar: false,
            search: "",
            snackbar_msg: "",
            color: "",
            snackbar: false,
            ay_std_div_list: null,
            sel_ay_data: null,
            semester_list: null,
            sem: null,
            fetch_loader: false,
            show: false,
            course_list: [],
            stud_list: [],
            awspath: "",
            registration_no: null,
            standard: null,
            div: null,
            ay: null,
            tenant: null,
            name: null,
            dob: null,
            roll_no: null,
            mobile_no: null,
            address: null,
            mother_name: null,
            photo: null,
            reg_no: null,
            gr_no: null,
            father_full_name: null,
            leraner_marksheet: [],
            semester: null,
            colspan: null,
            overall_grade: null,
            remark: [],
            org_basic_data: [],
            sem1: null,
            sem2: null,
            mother_contact: null,
            father_contact: null,
            allowedStandards: ["I", "II", "III", "IV", "V"],
            std:null,
            div:null,
            org:null,
            head_master_name: "--",
            head_master_sign: null,
            class_teacher_name: "--",
            class_teacher_sign: null,
            status: ''
        };
    },

    methods: {
        print() {
            this.$store.state.drawer = false;
            let that = this;
            window.onafterprint = function () {
                that.$store.state.drawer = true;
            };
            setTimeout(function () {
                window.print();
            }, 100);
        },
        showSnackbar(clr, msg) {
            this.snackbar = true;
            this.color = clr;
            this.snackbar_msg = msg;
        },
        onload() {
            this.overlay = true;
            const data = {
                lid: this.registration_no,
                ay: this.sel_ay_data,
                sem: this.sem,
                org: this.org,
            };
            console.log("data:", data);
            axios
                .post("/Examination/getAnnualStudentReport", data)
                .then((res) => {
                    if (res.data.flag == "NO") {
                        this.showSnackbar("#b71c1c", res.data.smsg); 
                        this.overlay = false;
                        return;
                    }
                    if (res.data.flag == "YES") {
                        this.standard = res.data.standard;
                        this.div = res.data.div;
                        this.ay = res.data.ay;
                        this.name = res.data.name;
                        this.dob = res.data.dob;
                        this.roll_no = res.data.roll_no;
                        this.mobile_no = res.data.mobile_no;
                        this.address = res.data.address;
                        this.mother_name = res.data.mother_name;
                        this.photo = res.data.photo;
                        this.reg_no = res.data.reg_no;
                        this.gr_no = res.data.gr_no;
                        this.father_full_name = res.data.father_full_name;
                        this.leraner_marksheet = [res.data];
                        this.semester = res.data.semester;
                        this.default_value = res.data.default_value;
                        this.org_basic_data = res.data.org_basic_data;
                        this.mother_contact = res.data.mother_contact;
                        this.father_contact = res.data.father_contact;
                        this.head_master_name = res.data.head_master_name || "--"
                        this.head_master_sign = res.data.head_master_sign || "--"
                        this.class_teacher_name = res.data.class_teacher_name || "--"
                        this.class_teacher_sign = res.data.class_teacher_sign || "--"
                        this.overlay = false;
                    }
                    if (res.data.flag == "NO") {
                        this.showSnackbar("#b71c1c", res.data.msg_flag); 
                        this.overlay = false;
                    }
                })
                .catch((error) => {
                    this.showSnackbar("#b71c1c", "Something went wrong..."); 
                    this.overlay = false;
                })
                .finally(() => { });
        },
        handleBulk() {
                this.overlay = true;
                const payload = {
                    ay: this.sel_ay_data,
                    sem: this.sem,
                    standard: this.std,
                    division: this.div,
                    org: this.org,
                    status: this.status,
                };                
                axios.post("/Examination/getBulkAnnualReport", payload)
                    .then((res) => {
                        if (res.data.flag === "YES") {                            
                            this.leraner_marksheet = res.data.data;
                            this.org_basic_data = res.data.org_basic_data;
                            this.overlay = false;
                        }
                        else if(res.data.flag === "NO"){
                            this.showSnackbar("#b71c1c", res.data.msg);
                            this.overlay = false;
                            return;
                        }                        
                    })
                    .catch(() => {
                        this.showSnackbar("#b71c1c", "Something went wrong...");
                        this.overlay = false;
                    })
                    .finally(() => {
                        // cleanup
                    });
        }

    },
    mounted() {
        this.awspath = localStorage.getItem("awspath");
        this.sel_ay_data = localStorage.getItem("setay");
        this.sem = localStorage.getItem("setsem");
        this.registration_no = localStorage.getItem("setreg_no");
        this.tenant = localStorage.getItem("EPS-tenant");
        this.std = localStorage.getItem("setstd");
        this.div = localStorage.getItem("setdiv");
        this.org = localStorage.getItem("EPS-org-id");
        this.status = localStorage.getItem("status");
        const isBulk = localStorage.getItem("isBulk");
          if (isBulk === "true") {
            this.handleBulk();
          } else {
            this.registration_no = localStorage.getItem("setreg_no");
            this.onload();
          }

    },
};
</script>
<style scoped>
.fixed-list li {
    margin-left: 1.5em;
}
.saisa-watermark {
  position: relative;
}

.saisa-watermark::before {
  content: "";
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  width: 70%;
  height: 70%;
  background-image: var(--wm-url);
  background-size: contain;
  background-position: center;
  background-repeat: no-repeat;
  opacity: 30%;
  z-index: 0;
  pointer-events: none;
}
.saisa-watermark > * {
  position: relative;
  z-index: 1;
}

.saisa-watermark .v-data-table,
.saisa-watermark table,
.saisa-watermark .v-simple-table,
.saisa-watermark td,
.saisa-watermark th,
.saisa-watermark tr,
.saisa-watermark tbody,
.saisa-watermark thead {
  background-color: transparent !important;
  background: transparent !important;
}
.watermark-img {
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  margin: auto;
  width: 70%;
  height: auto;
  display: block;
  opacity: 30%;
  z-index: 0;
  pointer-events: none;
}

.text_report {
    border: 3px solid black;
    margin: 1rem !important;
}

thead {
    font-weight: bold !important;
}

th {
    font-weight: bold !important;
}

tr,
td,
th {
    border: 1px solid black;
}

tr,
tbody {
    border-bottom: 1px solid black;
    border: 1px solid black;
}

@media (min-width: 320px) {

    td,
    th {
        display: table-cell !important;
        font-size: small;
    }

    td+td,
    th+th {
        width: auto;
        font-size: small;
    }
}

v-simple-table {
    white-space: nowrap !important;
}

.radiospace {
    margin: 1rem !important;
    padding: 0%;
}

.btn-css {
    outline: 0 !important;
    outline-offset: 0 !important;
    background-image: none !important;
    -webkit-box-shadow: none !important;
    box-shadow: none !important;
    background-color: #fff !important;
    text-decoration: underline;
    color: #0f2027 !important;
    text-align: left;
}

.btn-css:hover {
    outline: 0 !important;
    outline-offset: 0 !important;
    background-image: none !important;
    -webkit-box-shadow: none !important;
    box-shadow: none !important;
    background-color: #ffff !important;
    color: #0f2027 !important;
    text-decoration: underline;
    text-align: left;
}

.t-row {
    padding: 1rem i !important;
}

.mytable /deep/ thead th {
    background: #0f2027 !important;
    /* fallback for old browsers */
    background: -webkit-linear-gradient(to right, #2c5364, #203a43, #0f2027) !important;
    /* Chrome 10-25, Safari 5.1-6 */
    background: linear-gradient(to right, #2c5364, #203a43, #0f2027) !important;
    /* W3C, IE 10+/ Edge, Firefox 16+, Chrome 26+, Opera 12+, Safari 7+ */
    background-color: #0f2027 !important;
    color: white !important;
    font-weight: bold !important;
    white-space: nowrap !important;
    text-align: center;
}

.delete-avatar {
    transition: 0.3s;
    border: 1px solid red;
    margin: 0.2rem !important;
}

.delete-avatar:hover {
    background-color: transparent;
}

.delete-v-icon {
    padding-left: 8px;
    padding-top: 1px;
    font-size: 15px;
}

.delete-v-icon:hover {
    color: white;
}

.v-dialogss {
    bottom: 880;
    right: 0;
}
.signature-section{
    margin-top:auto;
}

@page {
    size: A4;
    margin-bottom: 0;
    padding-top: none;
    size: 11in 15.5in;
}

@media print and (-webkit-min-device-pixel-ratio: 0) {
    .print-font {
        font-size: 20px !important;
    }

    .v-data-table__wrapper {
        overflow-x: hidden;
        overflow-y: hidden;
    }

    .card {
        border: none !important;
        font-size: large !important;
        margin-top: -25px !important;
        box-shadow: none !important;         
    }

    .page-top {
        padding-top: 30px !important;
    }

    .pagebreak {
        page-break-before: always;
    }

    .full-height {
        height: 93vh;
    }

    header,
    footer,
    nav,
    date {
        display: none !important;
    }

    table,
    td,
    tr {
        break-inside: avoid-page;
        page-break-inside: auto;
    }

    body,
    tr,
    th,
    td {
        font-size: 22px !important;
        page-break-inside: auto;
        padding: 0 !important;
        word-wrap: break-word;
        margin: 0 !important;
    }

    td {
        font-size: 22px !important;
        word-wrap: break-word;
        padding: 1mm !important;
    }

    .font-size {
        font-size: 24px !important;
    }

    .no-display,
    .v-input__control,
    input[type="button"],
    input[type="submit"],
    input[type="reset"],
    #v-card {
        display: none !important;
    }

    v-card {
        border: none !important;
    }

    thead {
        font-weight: bold !important;
    }

    table,
    tr,
    th {
        text-align: center !important;
        margin-top: none;
        padding: none !important;
        border-bottom: 1px solid black;
        border: 1px solid black;
        page-break-inside: auto;
    }

    .div {
        width: 1450px !important;
        font-size: small;
        margin: 0 !important;
        border: 0px solid black;
    }
    .saisa-watermark::before {
        -webkit-print-color-adjust: exact !important;
        print-color-adjust: exact !important;
    }

    .saisa-watermark .v-data-table,
    .saisa-watermark table,
    .saisa-watermark .v-simple-table,
    .saisa-watermark td,
    .saisa-watermark th,
    .saisa-watermark tr,
    .saisa-watermark tbody,
    .saisa-watermark thead {
        background-color: transparent !important;
        background: transparent !important;
    } 

}

ol.s {
    list-style-type: inherit;
}

.stud-info {
    margin-left: 20px;
}

</style>